import { DOCUMENT } from '@angular/common';
import type { HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { NEVER } from 'rxjs';

import { AuthService } from '../../auth/services/auth.service';
import { disallowedJWTRoutes } from '../../core/constants';

export const preventUnauthRequestsInterceptor: HttpInterceptorFn = (request, next) => {
  const authService = inject(AuthService);
  const document = inject<Document>(DOCUMENT);

  if (!isDisallowedRoute(request, document)) {
    if (!authService.isLoggedIn()) {
      authService.logoutByHTTPInterception(request.url);
      return NEVER;
    }
  }
  return next(request);
};

function isDisallowedRoute(request: HttpRequest<unknown>, document: Document): boolean {
  const requestedUrl: URL = new URL(request.url, document.location.origin);
  let routes;
  if (document.location.pathname === '/login') {
    routes = [...disallowedJWTRoutes];
  } else if (['/lariuser', '/password-reset'].some(p => document.location.pathname.startsWith(p))) {
    routes = [...disallowedJWTRoutes, '/api/lariuser/current/', '/api/localisationsettings/'];
  } else {
    routes = [...disallowedJWTRoutes, '/api/localisationsettings/'];
  }

  return (
    routes.findIndex((route: string | RegExp) => {
      if (typeof route === 'string') {
        const parsedRoute: URL = new URL(route, document.location.origin);
        return parsedRoute.hostname === requestedUrl.hostname && parsedRoute.pathname === requestedUrl.pathname;
      }

      return route.test(request.url);
    }) > -1
  );
}
